<template>
  <div>
    <a-form-model :rules="rules" ref="ruleForm" :model="form" :label-col="labelCol"
                  :wrapper-col="wrapperCol">
      <a-form-model-item label="优惠券占位符">
        #{coupon}
      </a-form-model-item>
      <a-form-model-item :label="$t('message.txtManagement.tableTitle2')" prop="content_name">
        <a-input :size="$globalSize" v-model="form.content_name" :placeholder="$t('message.txtManagement.tableTitle2')"/>
      </a-form-model-item>
      <a-form-model-item label="文案标签" prop="content_tag_ids">
        <a-tree-select :size="$globalSize" show-search style="width: 100%" tree-checkable :maxTagCount="3" 
                       :replaceFields="{ children: 'children', title: 'title', key: 'id', value: 'id' }"
                       :tree-data="labelTreeData" v-model="form.content_tag_ids"
                       :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                       :placeholder="$t('message.txtManagement.AddFormTitle8')" allow-clear
                       tree-default-expand-all
                       treeNodeFilterProp="title">
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="文案内容" prop="content_detail">
        <div style="position: relative">
          <a-button  :size="$globalSize" 
              style="width: 120px;margin-bottom: 10px;position: absolute;bottom:5px;right: 10px;z-index: 2;border-radius: 8px;color: #bbbbbb"
              @click="$refs.selectTextModalRef.showModal()">
            <a-icon type="plus"></a-icon>
            文案库选择
          </a-button>
          <div id="exampleInputEmoji" @click.stop style="position: absolute;bottom:10px;right: 135px;z-index: 99999999;">
            <a-button  :size="$globalSize"  style="font-size:20px;border:none;width:30px;padding: 0;" @click.stop="toogleDialogEmoji">😃</a-button>
            <v-emoji-picker style="position: absolute;left: 0;top: 35px;" v-show="showEmojiDialog" labelSearch="Search" lang="pt-BR" @select="selectEmoji" :showSearch="false"></v-emoji-picker>
          </div>

          <a-textarea :size="$globalSize" id="emojiInput" v-model="form.content_detail" :rows="6" style="resize: none"/>
        </div>
      </a-form-model-item>
      <a-form-model-item label="添加附件" prop="attachments">
        <div class="appendix">
          <div class="preview-box" v-for="item in form.attachments" @mouseenter="item.showDelete = true"
               @mouseleave="item.showDelete = false">
            <img v-if="item.type === 'image'" :src="item.url" alt="">
            <!--            <video v-if="item.type === 'video'" :src="item.url" controls="controls"-->
            <!--                   style="width: 100%;height: 100%;object-fit: cover;"></video>-->

            <a-icon v-if="item.type==='video'" class="icon48" type="play-square"></a-icon>
            <div v-if="item.type==='docs'" style="width: 48px;height: 48px;">
              <img :src="matchLogo(item.name)" alt="">
            </div>
            <a-icon v-if="item.type==='link'" class="icon48" type="link"></a-icon>
            <a-icon v-if="item.type==='miniPro' && !item.url" class="icon48" type="code"></a-icon>
            <img v-if="item.type === 'miniPro' && item.url" :src="item.url" alt="">
            <div class="preview-name">
              {{ item.name }}
            </div>
            <div
                class="preview-delete"
                v-if="item.showDelete">
              <a-tooltip title="删除">
                <a-icon type="delete" style="cursor: pointer" @click="deleteItem(item)"></a-icon>
              </a-tooltip>
            </div>
          </div>
          <div @click.self="showMenu" class="upload-box"
               v-if="form.attachments.length < 4">
            <a-icon v-if="!uploadLoading" type="plus" class="upload-icon" @click="showMenu"></a-icon>
            <a-icon v-else type="loading" class="upload-icon"></a-icon>
            <a-menu
                :style="{position: 'absolute',top:menuPos.y+'px',left:menuPos.x+'px',border:'1px solid #ccc',boxShadow:'1px 1px #ccc',zIndex:999999}"
                v-if="menuVisible">
              <a-sub-menu key="docs">
                <span slot="title"><a-icon type="file-add"/><span>添加文件</span></span>
                <a-menu-item @click="uploadLocal('docs')">
                  本地选择
                </a-menu-item>
                <a-menu-item @click="$refs.uploadImgRef.showModalTest('docs')">
                  素材库选择
                </a-menu-item>
              </a-sub-menu>
              <a-sub-menu key="img">
                <span slot="title"><a-icon type="picture"/><span>添加图片</span></span>
                <a-menu-item @click="uploadLocal('image')">
                  本地选择
                </a-menu-item>
                <a-menu-item @click="$refs.uploadImgRef.showModalTest('image')">
                  素材库选择
                </a-menu-item>
              </a-sub-menu>
              <a-sub-menu key="video">
                <span slot="title"><a-icon type="play-square"/><span>添加视频</span></span>
                <a-menu-item @click="uploadLocal('video')">
                  本地选择
                </a-menu-item>
                <a-menu-item @click="$refs.uploadImgRef.showModalTest('video')">
                  素材库选择
                </a-menu-item>
              </a-sub-menu>
              <a-menu-item key="miniPro" @click="showAddModal('miniPro')">
                <a-icon type="code"/>
                添加小程序
              </a-menu-item>
              <a-menu-item key="link" @click="showAddModal('link')">
                <a-icon type="link"/>
                添加链接
              </a-menu-item>
            </a-menu>
          </div>
        </div>
      </a-form-model-item>
    </a-form-model>
    <text-library-select-modal ref="selectTextModalRef" @changeCopyWrite="syncText"></text-library-select-modal>
    <a-upload
        :accept="uploadAccept"
        list-type="picture-card"
        class="avatar-uploader"
        :show-upload-list="false"
        :before-upload="beforeUpload"
        @change="handleChange"
        style="display: none"
    >
      <a-button  :size="$globalSize"  type="primary" icon="upload" ref="uploadBtnRef" ></a-button>

    </a-upload>
    <upload-img
        ref="uploadImgRef"
        v-model="materialImg"
        :multiple="false"
        :show-preview="false"
        @initStep="()=>{}"
        @attachmentsChange="()=>{}">

    </upload-img>
    <add-link-modal
        ref="addLinkModalRef" @sync="addItem"></add-link-modal>
    <add-micro-app-modal
        ref="addMicroAppModalRef" @sync="addItem"></add-micro-app-modal>
  </div>
</template>

<script>
import utils from "@/utils";
import textLibrarySelectModal from "@/views/material/components/textLibrarySelectModal";
import materialUpload from "@/interface/pages/material/materialUpload";
import moment from "moment";
import uploadImg from "@/views/material/components/uploadImg";
import addLinkModal from "@/views/material/components/addLinkModal";
import addMicroAppModal from "@/views/material/components/addMicroAppModal";
import {matchFileLogo} from "@/utils/common";


export default {
  name: "EnterpriseWechatPushTemp",
  components: {
    textLibrarySelectModal,
    uploadImg,
    addMicroAppModal,
    addLinkModal,
  },
  inject: {
    parent: {
      from: 'parent'
    },
    changePreviewItem: {
      from: 'changePreviewItem',
      default: () => {
      }
    }
  },
  data() {
    return {
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 6 : 5
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 16 : 16
      },
      form: {
        content_name: '',
        content_tag_ids: [],
        content_detail: '',
        attachments: [],
      },
      labelTreeData: this.parent.labelTreeData,
      rules: {
        content_name: [{required: true, message: '请输入名称', trigger: 'blur'}],
        content_detail: [{required: true, message: this.$t('message.strategyStore.pleaseEnterContent'), trigger: 'blur'}],
      },
      menuVisible: false,

      menuPos: {
        x: 0,
        y: 0
      },
      uploadAccept: '*',
      uploadLoading: false,
      materialImg: '',
      emoji: '',
      showEmojiDialog: false
    }
  },
  watch: {
    form: {
      handler(v) {
        this.changePreviewItem && this.changePreviewItem({
          type: '企业微信',
          detail: v.content_detail,
          attachments: v.attachments
        })
      },
      deep: true,
      immediate: true
    },
    materialImg: {
      handler(v) {
        this.addItem({
          url: v.url,
          name: v.name,
          type: 'image',
          material: {...v}
        })
      },
      deep: true
    }
  },
  methods: {
    matchLogo(name) {
      const type = name.substring(name.lastIndexOf('.') + 1, name.length)
      return matchFileLogo(type)
    },
    showAddModal(type) {
      const ref = type === 'link' ? this.$refs.addLinkModalRef : this.$refs.addMicroAppModalRef
      this.menuVisible = false
      ref.showModal()
    },
    syncText(v) {
      this.form.content_detail = v
    },
    async formValidate() {
      let data
      await this.$refs.ruleForm.validate(async valid => {
        if (!valid) return
        data = {...this.form}
      })
      return {...data}
    },
    showMenu(e) {
      this.menuPos.x = e.layerX
      this.menuPos.y = e.layerY
      this.menuVisible = true
    },
    hideMenu(e) {
      if (e.target.tagName.toLowerCase() !== 'li' && e.target.tagName.toLowerCase() !== 'svg' && e.target.tagName.toLowerCase() !== 'path' && e.target.innerText !== '添加图片' && e.target.className !== 'upload-box') {
        this.menuVisible = false
      }
    },
    hideEmoji(e){
      if(e.target.id !== 'exampleInputEmoji'){
        this.showEmojiDialog = false
      }
    },
    uploadLocal(type) {
      this.uploadType = type
      switch (type) {
        case 'image':
          this.uploadAccept = 'image/gif,image/jpeg,image/jpg,image/png'
          break;
        case 'docs':
          this.uploadAccept = '.xls,.doc,.txt,.pdf,.ppt,.pptx,.xlsx,.docx,.zip,.rar,.7z,.gz,.tar,.tar.gz,.tar.bz2,.tar.xz,.tar.lz,.tar.'
          break;
        case 'video':
          this.uploadAccept = 'video/*'
          break;
      }
      setTimeout(() => {
        this.$refs.uploadBtnRef.$el.click()
      }, 0)
    },
    beforeUpload() {
      return false;
    },
    async uploadAttachments(file) {
      this.uploadLoading = true
      const {data: res} = await materialUpload.uploadAttachments(this, {
        data: {
          file_data: file,
        },
      });
      if (res.code === "200") {
        this.addItem({
          type: this.uploadType,
          url: res.data,
          name: file.name,
          size: this.renderSize(file.size)
        })
        this.$message.success('上传成功');
      } else {
        this.$message.error(res.message);
      }
      this.uploadLoading = false
    },
    renderSize(filesize) {
      if (null == filesize || filesize == '') {
        return "0 B";
      }
      let unitArr = new Array("B", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb");
      let index = 0;
      let srcsize = parseFloat(filesize);
      index = Math.floor(Math.log(srcsize) / Math.log(1024));
      let size = srcsize / Math.pow(1024, index);
      size = size.toFixed(2);//保留的小数位数
      return size + ' ' + unitArr[index];
    },
    handleChange(info) {
      this.uploadAttachments(info.file);
    },
    addItem(item) {
      this.form.attachments.push({id: moment().valueOf(), showDelete: false, ...item})
    },
    deleteItem(item) {
      this.form.attachments = this.form.attachments.filter(i => i.id !== item.id)
    },
    // 表情输入
    selectEmoji(emoji) {
      let elInput = document.getElementById('emojiInput')//获取输入框元素
      // console.log(elInput);
      let start = elInput.selectionStart // 记录光标开始的位置
      let end = elInput.selectionEnd // 记录选中的字符 最后的字符的位置
      if (start === undefined || end === undefined) return
      // 将表情添加到选中的光标位置
      this.form.content_detail = this.form.content_detail.substring(0, start) + emoji.data + this.form.content_detail.substring(end) // 赋值给input的value
      // 重置光标位置
      elInput.focus()
      this.$nextTick(()=>{
        elInput.selectionStart = start + emoji.data.length
        elInput.selectionEnd = start + emoji.data.length
      })
      this.showEmojiDialog = false
    },
    //打开表情弹窗
    toogleDialogEmoji() {
      this.showEmojiDialog = !this.showEmojiDialog
    },

  },
  mounted() {
    utils.languageChange(this, {labelCol: 8, wrapperCol: 16}, {labelCol: 6, wrapperCol: 16})
    if (this.parent.currentItem) {
      const arr = []
      this.parent.currentItem.attachments.forEach((i, index) => {
        arr.push({...i, showDelete: false, id: moment().valueOf() + index})
      })

      this.form = {
        ...this.parent.currentItem,
        attachments: arr,
        content_tag_ids: this.parent.currentItem.content_tag_ids ? this.parent.currentItem.content_tag_ids.split(',') : []
      }
    }
    window.addEventListener('click', this.hideMenu)
    window.addEventListener('click', this.hideEmoji)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.hideMenu)
    window.removeEventListener('click', this.hideEmoji)
  }
}
</script>

<style scoped lang="less">
.appendix {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  grid-gap: 10px;

  .preview-box, .upload-box {
    width: calc((100% - 10px) / 2);
    min-width: calc((100% - 10px) / 2);
    max-width: calc((100% - 10px));
    height: 100px;
    border: 1px solid #000;
    position: relative;
  }

  .preview-box {
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border: 1px solid #ccc;

    img {
      max-width: 100%;
      max-height: 100%;
    }

    .icon48 {
      font-size: 48px;
    }

    .preview-name {
      width: 100%;
      height: 20px;
      font-size: 14px;
      position: absolute;
      bottom: 0;
      margin: 0;
      padding: 0 5px;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      line-height: 20px;
    }

    .preview-delete {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.65);
      line-height: 100px;
      color: white;
      text-align: center
    }
  }

  .upload-box {
    text-align: center;
    line-height: 120px;
    cursor: pointer;
    overflow: unset;
    border: 1px solid #ccc;
    color: #ccc;

    .upload-icon {
      font-size: 50px;
    }
  }
}
</style>
